import * as i0 from '@angular/core';
import { Injectable, Pipe, EventEmitter, Component, Input, Output, NgModule } from '@angular/core';
import * as i1 from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { map, take } from 'rxjs/operators';
import { Subject, BehaviorSubject } from 'rxjs';
import { getSubTaskDetails } from 'visa-store';
import * as i2 from 'primeng/api';
import * as i3 from '@ngrx/store';
import * as i4 from '@angular/common';
import * as i5 from 'primeng/confirmdialog';
import * as i6 from '@angular/forms';
import { PrimengLibraryModule } from 'primeng-library';

class TaskNotesService {
    constructor(http) {
        this.http = http;
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json'
            })
        };
        this.onNotesUpdated = new Subject();
        this.updateNotesSubject = new BehaviorSubject({});
        this.updateNote$ = this.updateNotesSubject.asObservable();
    }
    getnotes(taskId, stepId) {
        return this.http.get(`/L1/task/${taskId}/step/${stepId}/notes`).pipe(map((response) => {
            return response;
        }));
    }
    savenotes(taskId, payload) {
        return this.http.post(`/L1/task/${taskId}/note/create`, payload).pipe(map((response) => {
            this.updateNotesSubject.next({
                notesAdded: payload.noteDetails,
                notesAvailable: true,
                taskStepId: payload.taskStepId
            });
            return response;
        }));
    }
    deletenotes(taskId, noteId) {
        return this.http.delete(`/L1/task/${taskId}/note/${noteId}/delete`).pipe(map((response) => {
            this.updateNotesSubject.next({
                notesAdded: '',
                notesAvailable: false,
            });
            return response;
        }));
    }
}
TaskNotesService.ɵfac = function TaskNotesService_Factory(t) { return new (t || TaskNotesService)(i0.ɵɵinject(i1.HttpClient)); };
TaskNotesService.ɵprov = i0.ɵɵdefineInjectable({ token: TaskNotesService, factory: TaskNotesService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TaskNotesService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();

class nl2brPipe {
    transform(value) {
        return value.replace(/\n/g, '<br/>');
    }
}
nl2brPipe.ɵfac = function nl2brPipe_Factory(t) { return new (t || nl2brPipe)(); };
nl2brPipe.ɵpipe = i0.ɵɵdefinePipe({ name: "nl2br", type: nl2brPipe, pure: true });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(nl2brPipe, [{
        type: Pipe,
        args: [{
                name: 'nl2br'
            }]
    }], null, null); })();

const _c0 = function (a0, a1) { return { "btn-warning": a0, "btn-outline-warning": a1 }; };
function TaskNotesLibComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵelementStart(1, "button", 3);
    i0.ɵɵlistener("click", function TaskNotesLibComponent_div_5_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r8); const ctx_r7 = i0.ɵɵnextContext(); return ctx_r7.showOthersNotes("Attorney"); });
    i0.ɵɵtext(2, " View Lawfirm Note ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(1, _c0, ctx_r0.highLightedBtn === "Attorney", ctx_r0.highLightedBtn === ""));
} }
function TaskNotesLibComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵelementStart(1, "button", 3);
    i0.ɵɵlistener("click", function TaskNotesLibComponent_div_6_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r10); const ctx_r9 = i0.ɵɵnextContext(); return ctx_r9.showOthersNotes("Petitioner"); });
    i0.ɵɵtext(2, " View Petitioner Note ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(1, _c0, ctx_r1.highLightedBtn === "Petitioner", ctx_r1.highLightedBtn === ""));
} }
function TaskNotesLibComponent_div_7_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 13);
    i0.ɵɵpipe(1, "nl2br");
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("innerHtml", i0.ɵɵpipeBind1(1, 1, ctx_r11.myNotes == null ? null : ctx_r11.myNotes.noteText), i0.ɵɵsanitizeHtml);
} }
function TaskNotesLibComponent_div_7_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵelementStart(1, "textarea", 15);
    i0.ɵɵlistener("ngModelChange", function TaskNotesLibComponent_div_7_div_2_Template_textarea_ngModelChange_1_listener($event) { i0.ɵɵrestoreView(_r14); const ctx_r13 = i0.ɵɵnextContext(2); return ctx_r13.myNotes.noteText = $event; });
    i0.ɵɵtext(2, "            ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngModel", ctx_r12.myNotes.noteText);
} }
function TaskNotesLibComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵtemplate(1, TaskNotesLibComponent_div_7_div_1_Template, 2, 3, "div", 11);
    i0.ɵɵtemplate(2, TaskNotesLibComponent_div_7_div_2_Template, 3, 1, "div", 12);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r2.editMode);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.editMode && ctx_r2.highLightedBtn === "");
} }
function TaskNotesLibComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r16 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵelementStart(1, "div", 2);
    i0.ɵɵelementStart(2, "button", 17);
    i0.ɵɵlistener("click", function TaskNotesLibComponent_div_8_Template_button_click_2_listener() { i0.ɵɵrestoreView(_r16); const ctx_r15 = i0.ɵɵnextContext(); return ctx_r15.saveNotes(); });
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", !ctx_r3.myNotes.noteText);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r3.myNotes.id === "" ? "Save" : "Update");
} }
function TaskNotesLibComponent_div_9_small_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "small");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r17 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate2("Last Updated By:", ctx_r17.myNotes == null ? null : ctx_r17.myNotes.lastUpdatedBy, " On: ", ctx_r17.myNotes == null ? null : ctx_r17.myNotes.lastUpdatedTime, "");
} }
function TaskNotesLibComponent_div_9_Template(rf, ctx) { if (rf & 1) {
    const _r19 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 18);
    i0.ɵɵelementStart(1, "div", 19);
    i0.ɵɵlistener("click", function TaskNotesLibComponent_div_9_Template_div_click_1_listener() { i0.ɵɵrestoreView(_r19); const ctx_r18 = i0.ɵɵnextContext(); return ctx_r18.onEdit(); });
    i0.ɵɵelement(2, "i", 20);
    i0.ɵɵelementStart(3, "span");
    i0.ɵɵtext(4, "Edit");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 19);
    i0.ɵɵlistener("click", function TaskNotesLibComponent_div_9_Template_div_click_5_listener($event) { i0.ɵɵrestoreView(_r19); const ctx_r20 = i0.ɵɵnextContext(); return ctx_r20.onDelete($event); });
    i0.ɵɵelement(6, "i", 21);
    i0.ɵɵelementStart(7, "span");
    i0.ɵɵtext(8, "Delete");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 22);
    i0.ɵɵtemplate(10, TaskNotesLibComponent_div_9_small_10_Template, 2, 2, "small", 23);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(10);
    i0.ɵɵproperty("ngIf", ctx_r4.myNotes.lastUpdatedBy && ctx_r4.myNotes.lastUpdatedTime);
} }
function TaskNotesLibComponent_div_10_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 13);
    i0.ɵɵpipe(1, "nl2br");
} if (rf & 2) {
    const ctx_r21 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("innerHtml", i0.ɵɵpipeBind1(1, 1, ctx_r21.otherNotes == null ? null : ctx_r21.otherNotes.noteText), i0.ɵɵsanitizeHtml);
} }
function TaskNotesLibComponent_div_10_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 25);
    i0.ɵɵtext(1, " No Notes Available ");
    i0.ɵɵelementEnd();
} }
function TaskNotesLibComponent_div_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵtemplate(1, TaskNotesLibComponent_div_10_div_1_Template, 2, 3, "div", 11);
    i0.ɵɵtemplate(2, TaskNotesLibComponent_div_10_div_2_Template, 2, 0, "div", 24);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r5.otherNotes == null ? null : ctx_r5.otherNotes.noteText);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !(ctx_r5.otherNotes == null ? null : ctx_r5.otherNotes.noteText));
} }
function TaskNotesLibComponent_div_11_small_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "small");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r23 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate2("Last Updated By:", ctx_r23.otherNotes == null ? null : ctx_r23.otherNotes.lastUpdatedBy, " On: ", ctx_r23.otherNotes == null ? null : ctx_r23.otherNotes.lastUpdatedTime, "");
} }
function TaskNotesLibComponent_div_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 18);
    i0.ɵɵelementStart(1, "div", 26);
    i0.ɵɵtemplate(2, TaskNotesLibComponent_div_11_small_2_Template, 2, 2, "small", 23);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", (ctx_r6.otherNotes == null ? null : ctx_r6.otherNotes.lastUpdatedBy) && (ctx_r6.otherNotes == null ? null : ctx_r6.otherNotes.lastUpdatedTime));
} }
class TaskNotesLibComponent {
    constructor(taskNoteService, confirmationService, store) {
        this.taskNoteService = taskNoteService;
        this.confirmationService = confirmationService;
        this.store = store;
        this._step = null;
        this.noteAdded = new EventEmitter();
        this.highLightedBtn = '';
        this.editMode = false;
        this.blankNotes = {
            id: '',
            lastUpdatedBy: '',
            lastUpdatedTime: '',
            noteText: '',
            notesTitle: ''
        };
        this.myNotes = null;
        this.otherNotes = null;
    }
    ngOnInit() {
        this._step = this.step;
        this.userType = localStorage.getItem('userTypeRole');
        this.store
            .select(getSubTaskDetails)
            .pipe(take(1))
            .subscribe((data) => {
            this.taskData = data;
        });
        this.getNotes();
    }
    showMyNotes() {
        this.highLightedBtn = '';
    }
    showOthersNotes(user) {
        if (user === 'Attorney') {
            this.highLightedBtn = 'Lawfirm';
        }
        else if (user === 'Petitioner') {
            this.highLightedBtn = 'Petitioner';
        }
        else {
            this.highLightedBtn = '';
        }
    }
    getNotes() {
        this.myNotes = null;
        this.otherNotes = null;
        this.editMode = false;
        this.taskNoteService.getnotes(this._step.taskId, this._step.id).subscribe((res) => {
            if ((res === null || res === void 0 ? void 0 : res.status) === 200) {
                const notes = (res === null || res === void 0 ? void 0 : res.data) || null;
                if (this.userType === 'Petitioner') {
                    this.myNotes = (notes === null || notes === void 0 ? void 0 : notes.Petitioner) || {
                        id: '',
                        lastUpdatedBy: '',
                        lastUpdatedTime: '',
                        noteText: '',
                        notesTitle: ''
                    };
                    this.otherNotes = (notes === null || notes === void 0 ? void 0 : notes.Attorney) || {
                        id: '',
                        lastUpdatedBy: '',
                        lastUpdatedTime: '',
                        noteText: '',
                        notesTitle: ''
                    };
                }
                else if (this.userType === 'Attorney') {
                    this.myNotes = (notes === null || notes === void 0 ? void 0 : notes.Attorney) || {
                        id: '',
                        lastUpdatedBy: '',
                        lastUpdatedTime: '',
                        noteText: '',
                        notesTitle: ''
                    };
                    this.otherNotes = (notes === null || notes === void 0 ? void 0 : notes.Petitioner) || {
                        id: '',
                        lastUpdatedBy: '',
                        lastUpdatedTime: '',
                        noteText: '',
                        notesTitle: ''
                    };
                }
                this.editMode = (this.myNotes.noteText) ? false : true;
            }
        });
    }
    saveNotes() {
        var _a;
        const payload = {
            companyId: (this.userType === 'Petitioner') ? this._step.companyId : (this._step.attorneyId || ((_a = this.taskData) === null || _a === void 0 ? void 0 : _a.attorneyId)),
            noteDetails: this.myNotes.noteText,
            noteTitle: '',
            taskStepId: this._step.id
        };
        if (this.myNotes.noteText) {
            this.taskNoteService.savenotes(this._step.taskId, payload).subscribe((response) => {
                if ((response === null || response === void 0 ? void 0 : response.status) === 200) {
                    // this.store.dispatch(loadSubTaskDetails({ taskId: this._step.taskId,  visaTypeCode: this._step.v}));
                    this.noteAdded.emit({
                        notesAvailable: true,
                        noteText: this.myNotes.noteText
                    });
                    this.getNotes();
                    this.taskNoteService.onNotesUpdated.next();
                }
            });
        }
    }
    onEdit() {
        this.editMode = true;
    }
    onDelete(e) {
        this.confirmationService.confirm({
            message: 'Are you sure you want to delete?',
            target: e.target,
            accept: () => {
                this.taskNoteService.deletenotes(this._step.taskId, this.myNotes.id).subscribe((res) => {
                    if ((res === null || res === void 0 ? void 0 : res.status) === 200) {
                        this.getNotes();
                        this.noteAdded.emit({
                            notesAvailable: false,
                            noteText: ''
                        });
                        this.taskNoteService.onNotesUpdated.next();
                    }
                });
            },
            reject: () => {
            }
        });
    }
}
TaskNotesLibComponent.ɵfac = function TaskNotesLibComponent_Factory(t) { return new (t || TaskNotesLibComponent)(i0.ɵɵdirectiveInject(TaskNotesService), i0.ɵɵdirectiveInject(i2.ConfirmationService), i0.ɵɵdirectiveInject(i3.Store)); };
TaskNotesLibComponent.ɵcmp = i0.ɵɵdefineComponent({ type: TaskNotesLibComponent, selectors: [["task-notes-lib"]], inputs: { step: "step" }, outputs: { noteAdded: "noteAdded" }, decls: 13, vars: 12, consts: [[1, "notes"], [1, "row", "header"], [1, "col-6", "p-0"], ["type", "button", 1, "btn", 3, "ngClass", "click"], ["class", "col-6", 4, "ngIf"], ["class", "row mt-2 notes-area", 4, "ngIf"], ["class", "row m-4 footer", 4, "ngIf"], ["class", "row mt-2 mb-2 editfooter", 4, "ngIf"], ["header", "Delete"], [1, "col-6"], [1, "row", "mt-2", "notes-area"], ["class", "col-12 mt-4 mb-4 note", 3, "innerHtml", 4, "ngIf"], ["class", "col-12 mt-4 mb-4", 4, "ngIf"], [1, "col-12", "mt-4", "mb-4", "note", 3, "innerHtml"], [1, "col-12", "mt-4", "mb-4"], ["autofocus", "", "name", "mynote", "rows", "4", "cols", "50", "maxlength", "5000", "placeholder", "Add your notes", 1, "text", 3, "ngModel", "ngModelChange"], [1, "row", "m-4", "footer"], [1, "btn", "btn-primary", "mt-0", "d-inline-block", 3, "disabled", "click"], [1, "row", "mt-2", "mb-2", "editfooter"], [1, "col-2", "mt-2", "p-0", "editmode", 3, "click"], [1, "fa", "fa-pencil"], [1, "fa", "fa-trash"], [1, "col", "pl-2", "mt-2", "editmode", "d-flex", "justify-content-center", "align-items-center"], [4, "ngIf"], ["class", "col-12 mt-4 mb-4 note", 4, "ngIf"], [1, "col-12", "mt-4", "mb-4", "note"], [1, "col-12", "pl-2", "mt-2", "editmode", "d-flex", "justify-content-center", "align-items-center"]], template: function TaskNotesLibComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelementStart(3, "button", 3);
        i0.ɵɵlistener("click", function TaskNotesLibComponent_Template_button_click_3_listener() { return ctx.showMyNotes(); });
        i0.ɵɵtext(4);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(5, TaskNotesLibComponent_div_5_Template, 3, 4, "div", 4);
        i0.ɵɵtemplate(6, TaskNotesLibComponent_div_6_Template, 3, 4, "div", 4);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(7, TaskNotesLibComponent_div_7_Template, 3, 2, "div", 5);
        i0.ɵɵtemplate(8, TaskNotesLibComponent_div_8_Template, 4, 2, "div", 6);
        i0.ɵɵtemplate(9, TaskNotesLibComponent_div_9_Template, 11, 1, "div", 7);
        i0.ɵɵtemplate(10, TaskNotesLibComponent_div_10_Template, 3, 2, "div", 5);
        i0.ɵɵtemplate(11, TaskNotesLibComponent_div_11_Template, 3, 1, "div", 7);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(12, "p-confirmDialog", 8);
    } if (rf & 2) {
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(9, _c0, ctx.highLightedBtn === "", ctx.highLightedBtn !== ""));
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1("", ctx.userType, " Note");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.userType !== "Attorney");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.userType !== "Petitioner");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.highLightedBtn === "");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.editMode && ctx.highLightedBtn === "");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.editMode && ctx.highLightedBtn === "");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.highLightedBtn !== "");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.highLightedBtn !== "");
    } }, directives: [i4.NgClass, i4.NgIf, i5.ConfirmDialog, i6.DefaultValueAccessor, i6.MaxLengthValidator, i6.NgControlStatus, i6.NgModel], pipes: [nl2brPipe], styles: [".notes[_ngcontent-%COMP%]{max-height:48vh;overflow-x:auto}.notes[_ngcontent-%COMP%]   .header[_ngcontent-%COMP%]   .btn[_ngcontent-%COMP%]{position:relative;width:100%;font-size:10px}.notes[_ngcontent-%COMP%]   .notes-area[_ngcontent-%COMP%]{width:100%;min-height:20vh;max-height:35vh}.notes[_ngcontent-%COMP%]   .notes-area[_ngcontent-%COMP%]   .text[_ngcontent-%COMP%]{height:18vh;width:100%}.notes[_ngcontent-%COMP%]   .notes-area[_ngcontent-%COMP%]   .note[_ngcontent-%COMP%]{height:20vh;overflow:auto}.notes[_ngcontent-%COMP%]   .editmode[_ngcontent-%COMP%]{font-size:16px;font-weight:700;cursor:pointer!important}.notes[_ngcontent-%COMP%]   .editfooter[_ngcontent-%COMP%]{display:flex;border-top:2px solid grey;color:#19a0da;align-items:center;font-size:14px;position:sticky;bottom:0}.notes[_ngcontent-%COMP%]   .footer-attorney[_ngcontent-%COMP%]{border-top:2px solid grey;display:flex;justify-content:space-around}.notes[_ngcontent-%COMP%]   .notesadded[_ngcontent-%COMP%]{height:18vh;width:100%}.btn-outline-warning[_ngcontent-%COMP%]{padding:0!important}.btn-outline-warning[_ngcontent-%COMP%]:hover{background:none!important}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TaskNotesLibComponent, [{
        type: Component,
        args: [{
                selector: 'task-notes-lib',
                templateUrl: './task-notes-lib.component.html',
                styleUrls: ['./task-notes-lib.component.scss'],
            }]
    }], function () { return [{ type: TaskNotesService }, { type: i2.ConfirmationService }, { type: i3.Store }]; }, { step: [{
            type: Input
        }], noteAdded: [{
            type: Output
        }] }); })();

class TaskNotesLibModule {
}
TaskNotesLibModule.ɵfac = function TaskNotesLibModule_Factory(t) { return new (t || TaskNotesLibModule)(); };
TaskNotesLibModule.ɵmod = i0.ɵɵdefineNgModule({ type: TaskNotesLibModule });
TaskNotesLibModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            PrimengLibraryModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(TaskNotesLibModule, { declarations: [TaskNotesLibComponent,
        nl2brPipe], imports: [PrimengLibraryModule], exports: [TaskNotesLibComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TaskNotesLibModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    TaskNotesLibComponent,
                    nl2brPipe
                ],
                imports: [
                    PrimengLibraryModule
                ],
                exports: [
                    TaskNotesLibComponent
                ]
            }]
    }], null, null); })();

/*
 * Public API Surface of task-notes-lib
 */

/**
 * Generated bundle index. Do not edit.
 */

export { TaskNotesLibComponent, TaskNotesLibModule, TaskNotesService };
//# sourceMappingURL=task-notes-lib.js.map
